import {Component, EventEmitter, Input, Output} from "@angular/core";
import {NameFilter} from "../../../../../../infrastructure/occasions/filters/NameFilter";
import {OccasionsSorting} from "../../../../../../domain/occasions/sorting/OccasionsSorting";
import {OccasionsFilters} from "../../../../../../domain/occasions/filters/OccasionsFilters";
import {Sorting} from "../../../../../../domain/occasions/sorting/Sorting";
import {IDeviceInfo} from "../../../../../device/IDeviceInfo";

declare var $:any;

@Component({
    selector: 'admin-occasions-filter',
    styleUrls: ['./adminOccasionFilter.scss'],
    templateUrl: './adminOccasionFilter.html'
})
export class AdminOccasionFilterComponent {

    @Input() occasionsFilters:OccasionsFilters;
    @Input() occasionsSorting:OccasionsSorting;

    @Output() refreshed:EventEmitter<void> = new EventEmitter<void>();

    public name:string;

    private nameFilter:NameFilter;

    constructor(public deviceInfo:IDeviceInfo) {
        this.nameFilter = new NameFilter();
    }

    ngOnInit(){
        this.occasionsFilters.AddFilter(this.nameFilter);
    }

    public onNameChanged(name:string){
        this.name = name;
        this.nameFilter.SetValue(name);
        this.occasionsFilters.Update();
    }

    public sortingPriceClicked(){
        let newSorting = this.occasionsSorting.PriceSorting() + 1;
        if(newSorting > Sorting.Descending){
            newSorting = Sorting.None;
        }
        this.occasionsSorting.SetPricingSorting(newSorting);
    }

    public sortingMileageClicked(){
        let newSorting = this.occasionsSorting.MileageSorting() + 1;
        if(newSorting > Sorting.Descending){
            newSorting = Sorting.None;
        }
        this.occasionsSorting.SetMileageSorting(newSorting);
    }

    public refresh(){
        this.refreshed.emit();
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/occasions/presentation/adminOccasionFilter/adminOccasionFilter.ts